import {Component, Input, ViewChild} from "@angular/core";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import { LayoutService } from "../services/layout.service";

@Component({
  standalone: false,
    template:`
      @if (!data.hideToggle) {
        @if (data.showTooltip) {
          <span
            [nbTooltip]="data.tooltipMessage"
            [nbTooltipStatus]="data.tooltipStatus || 'default'"
            nbTooltipPlacement="bottom"
            >
            <nb-toggle
              class="toggleTableComponent"
              [(checked)]="data.value"
              [disabled]="data.disabled"
              [contentEditable]="!data.disabled"
              (click)="onToggleChange($event)">
            </nb-toggle>
          </span>
        }
        @if (!data.showTooltip) {
          <nb-toggle
            class="toggleTableComponent"
            [(checked)]="data.value"
            [disabled]="data.disabled"
            [contentEditable]="!data.disabled"
            (click)="onToggleChange($event)">
          </nb-toggle>
        }
      } @else {
        <div [nbTooltipDisabled]="!data.showTooltip" [nbTooltip]="data.tooltipMessage" nbTooltipStatus="default" nbTooltipPlacement="bottom">-</div>
      }
      <ng-template #noToggle>
        <div [nbTooltipDisabled]="!data.showTooltip" [nbTooltip]="data.tooltipMessage" nbTooltipStatus="default" nbTooltipPlacement="bottom">-</div>
      </ng-template>
      <ng-template #confirmDialog>
        <nb-card>
          <nb-card-header>CONFIRM ACTION</nb-card-header>
          <nb-card-body>
            Are you sure?
          </nb-card-body>
          <nb-card-footer>
            <button nbButton status="danger" class="float-end" (click)="closeConfirmDialog(true)">CANCEL</button>
            <button nbButton status="primary" class="float-end me-1" (click)="confirmToggleEnable()">CONFIRM</button>
          </nb-card-footer>
        </nb-card>
      </ng-template>
      
      `,
    styleUrls: ['./toggle-button.component.scss'],
})
export class ToggleButtonCellComponent {
    @Input()
    data: any
    @ViewChild('confirmDialog') confirmDialog: any;
    dialogRef: NbDialogRef<any>;

    constructor(
        private dialogService: NbDialogService,
        private layoutService: LayoutService
    ) {
        this.revertChange = this.revertChange.bind(this);
        this.openConfirmDialog = this.openConfirmDialog.bind(this);
    }

    onToggleChange(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.data.disabled) {
            return;
        }
        if (this.data.confirmation) {
            this.openConfirmDialog();
        } else {
            this.data.value = !this.data.value;
            if (this.data.action) {
                this.data.action(this.revertChange);
            }
        }
    }

    revertChange(){
        this.data.value = !this.data.value;
    }

    openConfirmDialog() {
        this.layoutService.setOverlaySubject(true);
        this.dialogRef = this.dialogService.open(this.confirmDialog, { closeOnBackdropClick: false, closeOnEsc: false });
      }
    
    closeConfirmDialog() {
        this.layoutService.setOverlaySubject(false);
        this.dialogRef.close();
    }
    
    confirmToggleEnable() {
        this.data.value = !this.data.value;
        if (this.data.action) {
            this.data.action(this.revertChange);
        }
        this.closeConfirmDialog();
    }
}